<template>
    <div>
        <section class="itb-hero-cards" id="itb-realizations">
            <div class="container">
                <div
                    v-for="category in mainCategories"
                    class="itb-hero-card row d-flex align-content-center mx-0"
                >
                    <div
                        v-if="isResponsive"
                        class="itb-hero-responsive-image"
                        v-lazy:background-image="
                            category.image ? '/uploads/' + category.image : ''
                        "
                    ></div>
                    <div class="itb-fake-background">
                        <div
                            class="itb-lazy-loading-bg"
                            v-lazy:background-image="
                                category.image && !isResponsive
                                    ? '/uploads/' + category.image
                                    : '/images/articles/blank-bg.webp'
                            "
                        ></div>
                    </div>

                    <div
                        class="col-12 col-md-6 col-lg-4 mb-3 mb-md-0"
                        v-if="category.id % 2 > 0"
                    >
                        <div class="itb-card">
                            <h2 v-html="$t('constants.' + category.title)"></h2>
                            <p
                                v-html="$t('constants.' + category.subtitle)"
                            ></p>
                            <router-link
                                :to="{
                                    name: 'realizationsByCategory',
                                    params: {
                                        categoryAlias: category.alias
                                    }
                                }"
                                class="btn btn-secondary itb-btn-icon"
                            >
                                {{ $t("realizations.show_more") }}
                                <img
                                    src="/images/icons/4soft_icon_angle-right.svg"
                                    :alt="
                                        $t('general.button') +
                                            ' ' +
                                            $t(
                                                'main_category.show_all_realizations'
                                            )
                                    "
                                    class="itb-icon itb-angle-right-icon"
                                />
                            </router-link>
                        </div>
                    </div>

                    <div
                        class="col-12 col-md-6 col-lg-4 itb-references-alike-set"
                        v-for="(realization, index) in category['realizations']"
                        :class="[
                            category.id % 2 == 0 ? 'mb-3 mb-md-0' : '',
                            index == 1 ? 'd-none d-lg-block' : ''
                        ]"
                    >
                        <router-link
                            :to="{
                                name: 'realizationDetail',
                                params: {
                                    categoryAlias: category.alias,
                                    realizationAlias:
                                        realization.id + '-' + realization.alias
                                }
                            }"
                            class="text-decoration-none"
                        >
                            <div
                                class="card h-100 itb-lazy-loading-bg"
                                style="overflow: hidden"
                                v-lazy:background-image="
                                    realization.image
                                        ? '/uploads/' + realization.image
                                        : null
                                "
                            >
                                <div class="card-body d-flex p-0">
                                    <div class="itb-text align-self-end w-100">
                                        <h3 class="mb-0">
                                            {{
                                                realization.name +
                                                    ", " +
                                                    realization.location
                                            }}
                                        </h3>
                                        <p class="itb-h3-subtitle">
                                            {{
                                                $t("constants." + category.name)
                                            }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </router-link>
                    </div>

                    <div
                        class="col-12 col-md-6 col-lg-4"
                        v-if="category.id % 2 == 0"
                    >
                        <div class="itb-card right">
                            <h2 v-html="$t('constants.' + category.title)"></h2>
                            <p
                                v-html="$t('constants.' + category.subtitle)"
                            ></p>

                            <router-link
                                :to="{
                                    name: 'realizationsByCategory',
                                    params: {
                                        categoryAlias: category.alias
                                    }
                                }"
                                class="btn btn-primary itb-btn-icon"
                            >
                                {{ $t("realizations.show_more") }}
                                <img
                                    src="/images/icons/4soft_icon_angle-right.svg"
                                    :alt="
                                        $t('general.button') +
                                            ' ' +
                                            $t(
                                                'main_category.show_all_realizations'
                                            )
                                    "
                                    class="itb-icon itb-angle-right-icon"
                                />
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <BenefitsBar />
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import BenefitsBar from "../components/BenefitsBar";

export default {
    data() {
        return {
            mainCategories: [],
            isResponsive: false
        };
    },

    created() {
        this.onResize();
        window.addEventListener("resize", this.onResize);
    },

    beforeDestroy() {
        window.removeEventListener("resize", this.onResize);
    },

    components: {
        BenefitsBar
    },

    mounted() {
        axios
            .get("/getRealizationsPage")
            .then(response => {
                this.mainCategories = response.data.mainCategories;
                this.pageParams = response.data.params;

                this.setPageParams(this.pageParams);
            })
            .catch(error => {
                console.log(error);
            });
    },

    computed: {
        ...mapGetters({ appParams: "getAppParams" })
    },

    methods: {
        ...mapActions(["setPageParams"]),
        scrollToElement(elementId) {
            this.$parent.scrollToElement(elementId);
        },
        onResize() {
            if (window.innerWidth < 992) {
                this.isResponsive = true;
            } else {
                this.isResponsive = false;
            }
        }
    }
};
</script>
